import { Link } from 'react-router-dom'
import { Button, Row, Column, Spinner, Label, DateTimePicker } from '../../../components'
import Grid from '../../../components/components/Grid/Grid'
//import { GetAllExternalTemplateList } from '../hooks/Manage3rdPartyTemplateOperations'
import React, { useState, useEffect, Suspense, useContext } from 'react'
// import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import * as label from '../../../shared/util/label'
import * as constant from '../../../shared/util/constant'
import { ErrorBoundary } from 'react-error-boundary'
import { userSetupUtils } from '../../utils/UserSetupUtils'
import Loading from '../../../shared/components/Loading'
import ScrollTop from '../../../shared/components/scrollTopButton'
import { FallbackComponent } from '../../../shared/components/FallbackComponent';
import { AbilityContext } from '../../../shared/abilities/AbilityContext';
import UserSetupMiniTabs from '../UserSetupMiniTabs'
import { Accordion, Container, Navbar } from 'react-bootstrap'
import { FaChevronDown, FaChevronRight } from 'react-icons/fa'
import './../UserSetupGrid.scss';
import EmployeeSetupService from '../service/EmployeeSetupService';
import ExportToCsv from '../../../shared/components/ExportToCSV/ExportToCsv'
import { CustomerHistoryLabel as cstHistoryLabel } from '../../../shared/util/label'
import { CommonUtility } from '../../../Services/CommonUtility'

//import { constant } from 'lodash'
//import * as constant from '../../shared/util/constant'

// interface Props {
//   isSideBarCollapsed: boolean
//   // subject: any
// }

const UserSetupGrid = () => {
  // const subject = props.subject;
  const ability = useContext(AbilityContext);
  const dispatch = useDispatch()
  const canCreate = ability.can('create', constant.AdminSubject, constant.AdminScreenPrivileges.User_Setup);

  // const history = useHistory()
  const [highlightedMenu, setHighlightedMenu] = useState('3rdpartytemplate');
  const [open, setOpen] = useState("0");
  //const [loadData, loadDataFlag] = useState(0);

  //const { data, isLoading } = GetAllExternalTemplateList();
  const [data, setData] = useState([]);
  // if (loadData == 1) {
  //   //setData([]);
  //   fetchData();
  // }
  //var data=[];
  const [showFilters, setShowFilters] = useState(true);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [selectedColumnValue, setSelectedColumnValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [includeInactiveRecords, setIncludeInactiveStatus] = useState(false);
  const [activeRecord, setActiveRecord] = useState([])
  const [ErrorText, setErrorText] = useState('')
  const [isScrollTop, setScrollTop] = useState(false)
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [newUserAt, setNewUserAt] = useState(new Date());
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);
  const EmployeeSetupServiceInstance = new EmployeeSetupService();
  
  const handleLoading = () => {
    setLoading(false);
  }

  const loadDataFlag = (data) => {
    if (data) {
      fetchData();
    }
  };
  useEffect(() => {
    window.addEventListener("load", handleLoading)
    return () => window.removeEventListener("load", handleLoading);
  }, [])

  async function fetchData(fromDateValue?: Date | null, toDateValue?: Date | null) {
    const formattedFromDate = fromDateValue ? CommonUtility.datetimeToDateOnly(fromDateValue) : undefined;
    const formattedToDate = toDateValue ? CommonUtility.datetimeToDateOnly(toDateValue) : undefined;

    //setLoading(true)
    await userSetupUtils.getallUsersList(formattedFromDate, formattedToDate)
      .then(response => {
        setData(response);
      })
      .catch(error => console.error(error))
    //.finally(()=> setLoading(false));
  }

  useEffect(() => {
    //alert('called')
    fetchData();
    // highlightMenu();
  }, []);

  //#region Call when there is error occur on the page
  //  const FallbackComponent = ({ error, resetErrorBoundary }) => {
  //   console.log("An error occurred:");
  //   console.log(error.message);
  //   return (
  //       <div>
  //           <h1>An error occurred: {error.message}</h1>
  //           <button onClick={resetErrorBoundary}>Try again</button>
  //       </div>
  //   );
  // };


  useEffect(() => {
    if (isRowSelected) {
      setSelectedColumnValue((prevValue) => {
        if (prevValue !== selectedColumnValue) {
          return selectedColumnValue;
        }
        return prevValue;
      });
    }
  }, [isRowSelected]);

  useEffect(() => {

  }, [isRowSelected]);

  const handleSelectedRow = (selected, columnValue) => {
    setIsRowSelected(selected);
    setSelectedColumnValue(columnValue);
  };
  //#region Scroll to Top function 
  const getScrollPostionStatus = () => {
    var scrollPostion = window.pageYOffset;

    if (scrollPostion >= constant.SHOW_SCROLL_BUTTON_POSITION) {
      // setScrollTop(true)
    }
    else {
      //setScrollTop(false)
    }
  }
  useEffect(() => {
    window.addEventListener('scroll', getScrollPostionStatus, { passive: true });

    return () => {
      window.removeEventListener('scroll', getScrollPostionStatus)
    };
  }, []);
  //#endregion Scroll to Top function


  const routeChange = () => {
    //highlightMenu('3rdpartytemplate')
    // let path = '/Campaign/3rdPartyTemplateDetail';
    // history.push(path);
  }

  const setEmployee = (empId) => {
    setSelectedEmployee(empId);
  }

  const checkInactiveStatus = (event) => {
    if (event.target.checked) {
      setIncludeInactiveStatus(true)

    }
    else {
      setIncludeInactiveStatus(false)
    }
  }

  const handleNewEmp = (tab: string) => {
    setSelectedEmployee(null)
    setOpen(tab)
    setNewUserAt(new Date());
    };

    const handleResetDates = async () => {
      setFromDate(null);
      setToDate(null);
      await fetchData();
    };

    const handleGetResults = async () => {
      await fetchData(fromDate, toDate);
    };

    const historyAllEmp = async (): Promise<any[]> => {
        try {
        const formattedFromDate = fromDate ? CommonUtility.datetimeToDateOnly(fromDate) : undefined;
        const formattedToDate = toDate ? CommonUtility.datetimeToDateOnly(toDate) : undefined;
        const resp = await EmployeeSetupServiceInstance.getAllEmployeeHistory(formattedFromDate, formattedToDate);
            return (resp)
        } catch (e: any) {
            return [];
        }
    };

    const historyAllUsers = async (): Promise<any[]> => {
        try {
        const formattedFromDate = fromDate ? CommonUtility.datetimeToDateOnly(fromDate) : undefined;
        const formattedToDate = toDate ? CommonUtility.datetimeToDateOnly(toDate) : undefined;
        const resp = await EmployeeSetupServiceInstance.getAllUserHistory(formattedFromDate, formattedToDate);
            return (resp);
        } catch (e: any) {
            return [];
        }
    };

    const ExportAllEmployeeHistoryButton = (
        <span className="export-activity-btn-margin ms-2">
            <ExportToCsv
                onExport={historyAllEmp}
                headers={[
                    cstHistoryLabel.EMPLOYEE_EMAIL,
                    cstHistoryLabel.AGENCY_GROUP,
                    cstHistoryLabel.AGENCY,
                    cstHistoryLabel.SUPERVISOR,
                    cstHistoryLabel.TITLE,
                    cstHistoryLabel.EMPLOYMENT_TYPE,
                    cstHistoryLabel.ACTIVE_STATUS,
                    cstHistoryLabel.EMPLOYEE_CREATED_DATE,
                    cstHistoryLabel.EMPLOYEE_LAST_MODIFIED_DATE,
                    cstHistoryLabel.ROLE,
                    cstHistoryLabel.USER,
                    cstHistoryLabel.TIMESTAMP,
                    cstHistoryLabel.FIELD,
                    cstHistoryLabel.OLD_VALUE,
                    cstHistoryLabel.NEW_VALUE,
                    cstHistoryLabel.ACTION,
                    cstHistoryLabel.ENTITY
                ]}
                fileName={'History-Employee_All Setup.csv'}
                getRow={row => [
                    row.employeeEmail ?? '',
                    row.agencyGroup ?? '',
                    row.agency ?? '',
                    row.supervisor ?? '',
                    row.title ?? '',
                    row.employmentType ?? '',
                    row.activeStatus != null ? String(row.activeStatus) : '',
                    row.employeeCreatedDate ? new Date(row.employeeCreatedDate).toLocaleString('en-US') : '',
                    row.employeeLastModifiedDate ? new Date(row.employeeLastModifiedDate).toLocaleString('en-US') : '',
                    row.roleName ?? '',
                    row.changedBy,
                    new Date(row.changedDate).toLocaleString('en-US'),
                    (typeof row.fieldName === 'string' && row.fieldName.startsWith('_'))
                        ? CommonUtility.capitalizeFirstCharOfEachWord(row.fieldName.substring(1))
                        : CommonUtility.capitalizeFirstCharOfEachWord(row.fieldName),
                    row.oldValue,
                    row.newValue,
                    row.action,
                    row.entity
                ]}
                buttonLabel={label.EXPORT_ALL_EMPS_HISTORY}
                className={'btn btn-primary px-3 flex-shrink-0 user-setup-header-btn'}
                groupBy={r => r.modifiedUser ?? label.UNKNOWN}
                groupHeaderLabel={label.MODIFIED_EMPLOYEE}
            />
        </span>
    );

    const ExportAllUserHistoryButton = (
        <span className="export-activity-btn-margin">
            <ExportToCsv
                onExport={historyAllUsers}
                headers={[
                    cstHistoryLabel.USER,
                    cstHistoryLabel.TIMESTAMP,
                    cstHistoryLabel.FIELD,
                    cstHistoryLabel.OLD_VALUE,
                    cstHistoryLabel.NEW_VALUE,
                    cstHistoryLabel.ACTION,
                    cstHistoryLabel.ENTITY
                ]}
                fileName={'History-User_All Setup.csv'}
                getRow={row => [
                    row.changedBy,
                    new Date(row.changedDate).toLocaleString('en-US'),
                    (typeof row.fieldName === 'string' && row.fieldName.startsWith('_'))
                        ? CommonUtility.capitalizeFirstCharOfEachWord(row.fieldName.substring(1))
                        : CommonUtility.capitalizeFirstCharOfEachWord(row.fieldName),
                    row.oldValue,
                    row.newValue,
                    row.action,
                    row.entity
                ]}
                buttonLabel={label.EXPORT_ALL_USERS_HISTORY}
                className={'btn btn-primary px-3 flex-shrink-0 user-setup-header-btn'}
                groupBy={r => r.modifiedUser ?? label.UNKNOWN}
                groupHeaderLabel={label.MODIFIED_USER}
            />
        </span>
    );

      const isDateRangeInvalid = !!(fromDate && toDate && fromDate > toDate);
      const isGetResultsDisabled = (!fromDate && !toDate) || isDateRangeInvalid;
      const isResetDisabled = !fromDate && !toDate;

      const baseGridData = data !== undefined && data.length > 0 ? data :
        data !== undefined ? data.filter(item => item.status === null ? '' : item.status.toUpperCase() !== constant.INACTIVE.toUpperCase()) : [];

  return (
    <>
      <Column lg={12} md={12}>
        <span>{ErrorText}</span>
      </Column>

      <ErrorBoundary FallbackComponent={FallbackComponent}>

        <Container fluid className='px-4'>
          <div className='mb-2'>
            <Row>
              <Column lg={12} md={12} className="">
                <div className='d-flex justify-content-between align-items-center'>
                  <Navbar className="bg-transparent exportButtonWrapper">
                    <Navbar.Brand>{label.USER_SETUP}</Navbar.Brand>
                  </Navbar>
                  {/* <b className='navbar-brand'>{label.USER_SETUP}</b> */}
                    <div className='d-flex align-items-center gap-2 ms-auto me-2 flex-shrink-0'>
                      <Button autofocus onClick={() => handleNewEmp("1")} className='px-3 flex-shrink-0 user-setup-header-btn' disabled={!canCreate}>{label.NEW_EMPLOYEE.toLocaleUpperCase()}</Button>
                      <div className='user-setup-header-date-field'>
                        <DateTimePicker
                          selected={fromDate ?? undefined}
                          onChange={(date) => setFromDate(date ?? null)}
                          placeholderText={'From'}
                          maxDate={new Date()}
                          className='w-100'
                          popperClassName='user-setup-date-popper'
                        />
                      </div>
                      <div className='user-setup-header-date-field'>
                        <DateTimePicker
                          selected={toDate ?? undefined}
                          onChange={(date) => setToDate(date ?? null)}
                          placeholderText={'To'}
                          minDate={fromDate ?? undefined}
                          maxDate={new Date()}
                          className='w-100'
                          popperClassName='user-setup-date-popper'
                        />
                      </div>
                      <Button
                        className='px-3 flex-shrink-0 user-setup-header-btn'
                        color='primary'
                        disabled={isGetResultsDisabled}
                        onClick={handleGetResults}
                      >
                        GET RESULTS
                      </Button>
                      <Button
                        className='px-3 flex-shrink-0 user-setup-header-btn'
                        color='primary'
                        onClick={handleResetDates}
                        disabled={isResetDisabled}
                      >
                        RESET
                      </Button>
                    </div>
                    {ExportAllEmployeeHistoryButton} {ExportAllUserHistoryButton}
                </div>
              </Column>

            </Row>
          </div>
          <Accordion activeKey={open} key="grid-accordion">
            <div className='card shadow' key="grid-card">
              {/* <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => setOpen(open !== "0" ? "0" : null)} className="customToggle">
            {open === "0" ? <FaChevronDown /> : <FaChevronRight />} {label.USER_SEARCH_FILTER}
          </Accordion.Toggle> */}
              <Accordion.Collapse eventKey="0" key="grid-collapse">
                <div>
                  {/* <Row className='gridrow'> */}
                  {/* <Suspense fallback={<Loading />}> */}
                  <Grid
                    key="user-grid"
                    data={baseGridData}
                    showFilters={showFilters}
                    columns={[
                      {
                        Header: label.EmployeeId,
                        accessor: 'id',
                        Cell: row => <div><span title={row.value}>{data !== undefined ? row.value : ''}</span></div>

                      },
                      {

                        Header: label.EMAIL,
                        accessor: 'eMail',
                        dataType: 'string',
                        sortType: (rowA, rowB) => {
                                const emailA = rowA.original.eMail || '';
                                const emailB = rowB.original.eMail || '';
                                return emailA.localeCompare(emailB); // Compare email strings
                              },
                        Cell: ({ row }) =>
                          <div><Link
                            // to={{
                            //   pathname: '/Campaign/3rdPartyTemplateDetail',
                            //   state: { entityId: row.original.id, type: "3" },// Pass the row data as state
                            //   search :"?id="+row.original.id
                            // }}
                            href='#'
                            onClick={(event) => {
                              event.preventDefault()
                              setOpen("1")
                              setEmployee(row.original.id)
                              setNewUserAt(new Date()) // Force refresh even for same employee
                              // set the data to be passed to the mini tabs here.
                            }}
                            className='text-start text-decoration-none'
                            title={row.original.eMail}>{data !== undefined ? row.original.eMail : ''}</Link></div>,
                        width: 250,
                        minWidth: 150
                      },
                      {
                        Header: label.FIRST_NAME,
                        accessor: 'firstName',
                        // useFilters:()=>{getInactiveRecords},
                        Cell: row => <div><span title={row.value}>{data !== undefined ? row.value : ''}</span></div>,
                        width: 250,
                        minWidth: 150,
                        dataType: 'string',
                      },
                      {
                        Header: label.LAST_NAME,
                        accessor: 'lastName',
                        Cell: row => <div><span title={row.value}>{data !== undefined ? row.value : ''}</span></div>,
                        width: 250,
                        minWidth: 150,
                        dataType: 'string',
                      },
                      {
                        Header: label.AGENCY,
                        accessor: 'agencyName',
                        Cell: row => <div><span title={row.value}>{data !== undefined ? row.value : ''}</span></div>,
                        width: 250,
                        minWidth: 150,
                        dataType: 'string',
                      },
                      {
                        Header: label.STATUS,
                        accessor: 'employeeStatus',
                        Cell: row => <div><span title={row.value} className={row.value === constant.ACTIVE ? "activeStatus" : row.value === constant.INACTIVE ? "inactiveStatus" : ""}>{data !== undefined ? row.value : ''}</span></div>,
                        width: 250,
                        minWidth: 150,
                        dataType: 'string',
                      },
                      {
                        Header: label.USER_SETUP,
                        accessor: 'userSetupCompleted',
                        Cell: row => <div><span title={row.value}>{data !== undefined ? row.value : ''}</span></div>,
                        width: 250,
                        minWidth: 150,
                        dataType: 'string',
                      },
                      {
                        Header: label.LastLogin,
                        accessor: 'lastLogin',
                        Cell: row => <div><span title={row.value}>{data !== undefined && row.value !== null ? CommonUtility.formateDateTime(new Date(row.value), CommonUtility.DateTimeFormatWithSecond) : ''}</span></div>,
                        width: 250,
                        minWidth: 150,
                        dataType: 'string',
                      }
                    ]}
                    hiddenColumns={['id', 'selection']}
                    sortDefault={[{ id: 'LastLogin', desc: false }, { id: 'employeeStatus', desc: false }]}
                    id={'tblExternalTemplate'}

                  />
                  {/* </Suspense> */}
                  {/* {loading && <Spinner color="blue" loading size={[10, 25]} type="FadeLoader" />} */}

                  <ScrollTop isDisplay={isScrollTop} />
                  {/* </Row> */}
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
          <Accordion activeKey={open} style={{ marginBottom: '20px' }} key="details-accordion">
            <div className='card shadow'>
              {/* <Accordion.Toggle as={Card.Header} eventKey="1" onClick={() => setOpen(open !== "1" ? "1" : null)} className="customToggle">
            {open === "1" ? <FaChevronDown /> : <FaChevronRight />} {label.USER_SEARCH_DETAILS}
          </Accordion.Toggle> */}
              <Accordion.Collapse eventKey="1">
                <div>
                  {<UserSetupMiniTabs selectedEmployee={selectedEmployee} key={newUserAt} setOpen={setOpen} loadDataFlag={loadDataFlag} />}
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </Container>

      </ErrorBoundary>
    </>
  )
}
export default UserSetupGrid;